import { render, staticRenderFns } from "./heating-relay.vue?vue&type=template&id=0a39c8fb&"
import script from "./heating-relay.vue?vue&type=script&lang=js&"
export * from "./heating-relay.vue?vue&type=script&lang=js&"
import style0 from "./heating-relay.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports